import Disclaimer from "../Components/Disclaimer";
import routes from "../routes";

export default function Home() {
    const opsRoutes = routes.filter(r => r.type === 'Ops');
    const mktsRoutes = routes.filter(r => r.type === 'Mkts');

    const renderRoute = (r: typeof routes[number], idx: number) => (
        <div key={r.route || idx}>
            <a href={`/charts${r.route}`}>{r.name}</a>
            {r.options?.map((o: typeof r.options[number], oidx: number) =>
                <span key={o.option || oidx}>
                    &nbsp; | &nbsp;
                    <a href={`/charts${r.route}?${o.option}`}>{o.description}</a>
                </span>
            )}
            {r.addLineBreak && <br />}
            <br />
        </div>
    );

    return(
        <div className="home"> 
            <div className="banner">
                <div className="banner-title">
                    MISO Public Charts {(process.env.NODE_ENV !== "production") ? ` - ${process.env.NODE_ENV}` : ""} - {(process.env.REACT_APP_VERSION) ? `v${process.env.REACT_APP_VERSION}` : ""}
                </div>
            </div>

            <h2>Current Charts:</h2>
            <div style={{ display: 'flex', gap: '2rem', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                    <h3>Operations</h3>
                    {opsRoutes.map(renderRoute)}
                </div>
                <div style={{ flex: 1 }}>
                    <h3>Markets</h3>
                    {mktsRoutes.map(renderRoute)}
                </div>
            </div>
            <div className="bottom">
                <Disclaimer extraMargin={false} />
            </div>
        </div>
    )
}